import {
  Period as PeriodEnum,
  Source as SourceEnum,
  Granularity as GranularityEnum,
  Previous as PreviousEnum,
  Collection as CollectionEnum,
  AuditLogAction as AuditLogActionEnum,
  AnalysisCalculation as AnalysisCalculationEnum,
  ConsumptionAnalysisKind as ConsumptionAnalysisKindEnum,
  AnalysisType,
  SerieCategory as SerieCategoryEnum,
} from '@enmon/commons/lib/enmon';
import { Commodity } from '@enmon/commons/lib/shared';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from './root';

export const GRANULARITY_TRANSLATED = defineMessages<GranularityEnum>({
  [GranularityEnum.Quarterhour]: { id: 'app.components.Filter.Granularity.quarter-hour' },
  [GranularityEnum.Hour]: { id: 'app.components.Filter.Granularity.hour' },
  [GranularityEnum.Day]: { id: 'app.components.Filter.Granularity.day' },
  [GranularityEnum.Week]: { id: 'app.components.Filter.Granularity.week' },
  [GranularityEnum.Month]: { id: 'app.components.Filter.Granularity.month' },
  [GranularityEnum.Quarter]: { id: 'app.common.supplyPoint.billingPeriod.quarter' },
  [GranularityEnum.Year]: { id: 'app.components.Filter.Granularity.year' },
  [GranularityEnum.Period]: { id: 'app.components.Filter.Granularity.whole-period' },
  [GranularityEnum.Exact]: { id: 'app.components.Filter.Granularity.exact' },
});

export const SOURCE_TRANSLATED = defineMessages<SourceEnum>({
  [SourceEnum.Invoice]: APP_DICTIONARY.invoice,
  [SourceEnum.Manual]: APP_DICTIONARY.manualReading,
  [SourceEnum.Sensor]: APP_DICTIONARY.remoteReading,
  [SourceEnum.Emission]: { id: 'app.components.Filter.Sources.emission' },
  [SourceEnum.Virtual]: { id: 'app.components.Filter.Sources.virtual' },
});

export const PERIOD_TRANSLATED = defineMessages<PeriodEnum>({
  [PeriodEnum.Last24hours]: { id: 'app.components.Filter.Period.last24Hours' },
  [PeriodEnum.Yesterday]: { id: 'app.components.Filter.Period.yesterday' },
  [PeriodEnum.Last7days]: { id: 'app.components.Filter.Period.last7Days' },
  [PeriodEnum.Last30days]: { id: 'app.components.Filter.Period.last30Days' },
  [PeriodEnum.PreviousWeek]: { id: 'app.components.Filter.Period.previousWeek' },
  [PeriodEnum.PreviousMonth]: { id: 'app.components.Filter.Period.previousMonth' },
  [PeriodEnum.PreviousYear]: { id: 'app.components.Filter.Period.previousYear' },
  [PeriodEnum.PreviousQuarter]: { id: 'app.components.Filter.Period.previousQuarter' },
  [PeriodEnum.Last3months]: { id: 'app.components.Filter.Period.last3Months' },
  [PeriodEnum.Last12months]: { id: 'app.components.Filter.Period.last12Months' },
  [PeriodEnum.Last24months]: { id: 'app.components.Filter.Period.last24Months' },
  [PeriodEnum.Last36months]: { id: 'app.components.Filter.Period.last36Months' },
  [PeriodEnum.ThisWeek]: { id: 'app.components.Filter.Period.thisWeek' },
  [PeriodEnum.ThisMonth]: { id: 'app.components.Filter.Period.thisMonth' },
  [PeriodEnum.ThisYear]: { id: 'app.components.Filter.Period.thisYear' },
  [PeriodEnum.Custom]: APP_DICTIONARY.custom,
  [PeriodEnum.Last]: { id: 'app.components.Filter.Period.last' },
  [PeriodEnum.Last6months]: { id: 'app.components.Filter.Period.last6months' },
  [PeriodEnum.LastDay]: { id: 'app.components.Filter.Period.lastDay' },
  [PeriodEnum.LastHour]: { id: 'app.components.Filter.Period.lastHour' },
  [PeriodEnum.LastQuarterhour]: { id: 'app.components.Filter.Period.lastQuarterhour' },
});

export const PREVIOUS_TRANSLATED = defineMessages<PreviousEnum>({
  [PreviousEnum.One]: { id: 'app.components.Filter.Previous.onePrevious' },
  [PreviousEnum.Two]: { id: 'app.components.Filter.Previous.twoPrevious' },
  [PreviousEnum.Year]: { id: 'app.components.Filter.Previous.yearPrevious' },
  [PreviousEnum.Exact]: APP_DICTIONARY.custom,
});

export const COMMODITY_TRANSLATED = defineMessages<Commodity>({
  [Commodity.Electricity]: APP_DICTIONARY.electricity,
  [Commodity.NaturalGas]: APP_DICTIONARY.gas,
  [Commodity.Water]: APP_DICTIONARY.water,
  [Commodity.Thermal]: APP_DICTIONARY.thermal,
  [Commodity.Other]: APP_DICTIONARY.otherCommodity,
});

export const COMMODITY_TRANSLATED_SHORT = defineMessages<Commodity>({
  [Commodity.Electricity]: APP_DICTIONARY.electricityShort,
  [Commodity.NaturalGas]: APP_DICTIONARY.gasShort,
  [Commodity.Water]: APP_DICTIONARY.waterShort,
  [Commodity.Thermal]: APP_DICTIONARY.thermalShort,
  [Commodity.Other]: APP_DICTIONARY.otherCommodityShort,
});

export const EXTERNAL_DATA_COMMODITY_TRANSLATED = defineMessages({
  StockPrice: { id: 'app.common.externalDataCommodity.stockPrice' },
  ExternalDataCommodity: { id: 'app.common.externalDataCommodity.weatherData' },
});

export const AUDIT_LOG_ACTION_TRANSLATED = defineMessages<AuditLogActionEnum>({
  [AuditLogActionEnum.Create]: { id: 'app.common.auditLogActions.create' },
  [AuditLogActionEnum.Update]: { id: 'app.common.auditLogActions.update' },
  [AuditLogActionEnum.Delete]: { id: 'app.common.auditLogActions.delete' },
  [AuditLogActionEnum.Login]: { id: 'app.common.auditLogActions.login' },
});

export const COLLECTION_TRANSLATED = defineMessages<
  CollectionEnum | 'InvoiceRecord' | 'ManualRecord' | 'SensorConsumptionRecord' | 'SensorValueRecord'
>({
  [CollectionEnum.AuditLogs]: { id: 'app.common.collections.auditLogs' },
  [CollectionEnum.Billings]: { id: 'app.common.collections.billings' },
  [CollectionEnum.BillingSettings]: { id: 'app.common.collections.billingSettings' },
  [CollectionEnum.Caches]: { id: 'app.common.collections.caches' },
  [CollectionEnum.CreditInvoices]: { id: 'app.common.collections.creditInvoices' },
  [CollectionEnum.Customers]: { id: 'app.common.collections.customers' },
  [CollectionEnum.EmissionFactorValidities]: { id: 'app.common.collections.emissionFactorValidities' },
  [CollectionEnum.EmissionFactors]: APP_DICTIONARY.emissionFactor,
  [CollectionEnum.EmissionRecords]: { id: 'app.common.collections.emissionRecords' },
  [CollectionEnum.EstablishmentSensorConsumption]: { id: 'app.common.collections.establishmentSensorConsumption' },
  [CollectionEnum.Establishments]: APP_DICTIONARY.establishment,
  [CollectionEnum.Exports]: { id: 'app.common.collections.exports' },
  [CollectionEnum.Files]: { id: 'app.common.collections.files' },
  [CollectionEnum.FloorPlans]: { id: 'app.common.collections.floorPlans' },
  [CollectionEnum.Gateways]: { id: 'app.common.collections.gateways' },
  [CollectionEnum.InvoiceRecords]: APP_DICTIONARY.invoice,
  [CollectionEnum.LeaseUnits]: { id: 'app.common.collections.leaseUnits' },
  [CollectionEnum.Leases]: { id: 'app.common.collections.leases' },
  [CollectionEnum.LicensesUsages]: { id: 'app.common.collections.licensesUsages' },
  [CollectionEnum.ManualRecords]: { id: 'app.common.collections.manualRecords' },
  [CollectionEnum.Meters]: APP_DICTIONARY.meter,
  [CollectionEnum.NotificationSettings]: { id: 'app.common.collections.notificationSettings' },
  [CollectionEnum.Notifications]: APP_DICTIONARY.notification,
  [CollectionEnum.Revisions]: { id: 'app.common.collections.revisions' },
  [CollectionEnum.SupplyPointRevisions]: { id: 'app.common.collections.supplyPointRevisions' },
  [CollectionEnum.SensorConsumptionRecords]: { id: 'app.common.collections.sensorConsumptionRecords' },
  [CollectionEnum.SensorValueRecords]: { id: 'app.common.collections.sensorValueRecords' },
  [CollectionEnum.SupplyPointNotifications]: { id: 'app.common.collections.supplyPointNotifications' },
  [CollectionEnum.SupplyPoints]: APP_DICTIONARY.supplyPoint,
  [CollectionEnum.Tenants]: { id: 'app.common.collections.tenants' },
  [CollectionEnum.ThirdParties]: { id: 'app.common.collections.thirdParties' },
  [CollectionEnum.Tokens]: { id: 'app.common.collections.tokens' },
  [CollectionEnum.Users]: { id: 'app.common.collections.users' },
  [CollectionEnum.RawReadings]: { id: 'app.common.collections.rawReadings' },
  [CollectionEnum.ValueReadings]: { id: 'app.common.collections.valueReadings' },
  [CollectionEnum.ConsumptionReadings]: { id: 'app.common.collections.consumptionReadings' },
  [CollectionEnum.DailyConsumptionReadings]: { id: 'app.common.collections.dailyConsumptionReadings' },
  // NOTE: Support old atlas model names
  InvoiceRecord: APP_DICTIONARY.invoice,
  ManualRecord: { id: 'app.common.collections.manualRecords' },
  SensorConsumptionRecord: { id: 'app.common.collections.sensorConsumptionRecords' },
  SensorValueRecord: { id: 'app.common.collections.sensorValueRecords' },
});

export const ANALYSIS_CALCULATION_TRANSLATED = defineMessages<AnalysisCalculationEnum>({
  [AnalysisCalculationEnum.Max]: APP_DICTIONARY.maximum,
  [AnalysisCalculationEnum.Min]: APP_DICTIONARY.minimum,
  [AnalysisCalculationEnum.Average]: APP_DICTIONARY.average,
  [AnalysisCalculationEnum.Sum]: { id: 'app.common.analysisCalculation.sum' },
  [AnalysisCalculationEnum.SumPerM2]: { id: 'app.common.analysisCalculation.sumPerM2' },
  [AnalysisCalculationEnum.SumPerUnit]: { id: 'app.common.analysisCalculation.sumPerUnit' },
  [AnalysisCalculationEnum.DegreeDays]: { id: 'app.common.analysisCalculation.degreeDays' },
});

export const ANALYSIS_TYPE_TRANSLATED = defineMessages<AnalysisType>({
  [AnalysisType.ExternalData]: { id: 'app.common.analysis.analysisType.externalData' },
  [AnalysisType.Consumption]: APP_DICTIONARY.consumption,
  [AnalysisType.Cost]: APP_DICTIONARY.cost,
  [AnalysisType.CarbonFootprint]: APP_DICTIONARY.carbonFootprint,
  [AnalysisType.Invoices]: APP_DICTIONARY.invoices,
  [AnalysisType.Values]: APP_DICTIONARY.values,
  [AnalysisType.ChartCategories]: { id: 'app.common.analysis.analysisType.chartCategories' },
  [AnalysisType.Licenses]: { id: 'app.common.analysis.analysisType.licenses' },
  [AnalysisType.DataIntegrity]: { id: 'app.common.analysis.analysisType.dataIntegrity' },
  [AnalysisType.SupplyPoints]: APP_DICTIONARY.supplyPoints,
  [AnalysisType.Counter]: { id: 'app.common.consumptionAnalysisKind.counter' },
  [AnalysisType.Max]: APP_DICTIONARY.quarterhourMax,
  [AnalysisType.Usage]: { id: 'app.common.consumptionAnalysisKind.usage' },
  [AnalysisType.Hierarchy]: APP_DICTIONARY.hierarchy,
});

export const ANALYSIS_SERIE_CATEGORY_TRANSLATED = defineMessages<SerieCategoryEnum>({
  [SerieCategoryEnum.Energy]: { id: 'app.common.serieCategory.energy' },
  [SerieCategoryEnum.Water]: { id: 'app.common.serieCategory.water' },
  [SerieCategoryEnum.Meteo]: { id: 'app.common.serieCategory.meteo' },
  [SerieCategoryEnum.Integrity]: { id: 'app.common.serieCategory.integrity' },
  [SerieCategoryEnum.IntegrityState]: { id: 'app.common.serieCategory.integrity' },
  [SerieCategoryEnum.MissingInvoice]: { id: 'app.common.serieCategory.missing-invoice' },
  [SerieCategoryEnum.MissingConsumption]: { id: 'app.common.serieCategory.missing-consumption' },
  [SerieCategoryEnum.TemperatureInside]: { id: 'app.common.serieCategory.temperature-in' },
  [SerieCategoryEnum.TemperatureOutside]: { id: 'app.common.serieCategory.temperature-out' },
  [SerieCategoryEnum.HeatingDegreeDays]: { id: 'app.common.serieCategory.heatingDegreeDays' },
  [SerieCategoryEnum.HeatingDays]: { id: 'app.common.serieCategory.heatingDays' },
  [SerieCategoryEnum.CoolingDegreeDays]: { id: 'app.common.serieCategory.coolingDegreeDays' },
  [SerieCategoryEnum.CoolingDays]: { id: 'app.common.serieCategory.coolingDays' },
  [SerieCategoryEnum.Counter]: { id: 'app.common.consumptionAnalysisKind.counter' },
  [SerieCategoryEnum.Cost]: APP_DICTIONARY.cost,
  [SerieCategoryEnum.CostCalculated]: APP_DICTIONARY.cost,
  [SerieCategoryEnum.Max]: APP_DICTIONARY.maximum,
});

export const CONSUMPTION_ANALYSIS_KIND_TRANSLATED = defineMessages<ConsumptionAnalysisKindEnum>({
  [ConsumptionAnalysisKindEnum.Counter]: { id: 'app.common.consumptionAnalysisKind.counter' },
  [ConsumptionAnalysisKindEnum.Max]: APP_DICTIONARY.quarterhourMax,
  [ConsumptionAnalysisKindEnum.Total]: APP_DICTIONARY.consumption,
  [ConsumptionAnalysisKindEnum.Usage]: { id: 'app.common.consumptionAnalysisKind.usage' },
});
